document.addEventListener("DOMContentLoaded", (event) => {
    initSwiper();
    if(window.variantsImagesSwiper){
        document.addEventListener('change', (e) => {
            const id = e.detail?.id;
            if (id) {
                onUpdateVariantsImages(id);
            } else {
                hideVariantsImages()
            }
        });
    }
});

function initSwiper () {
    const swiperEl = document.querySelector('.cb-variants-related-images-swiper');
    if (!swiperEl) return;
    const swiper = new Swiper(swiperEl, {
        pagination: {
            el: ".cb-swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".cb-swiper-button-next",
            prevEl: ".cb-swiper-button-prev",
        },
    });
    window.variantsImagesSwiper = swiper;
}

function onUpdateVariantsImages (variantId) {
    const swiper = window.variantsImagesSwiper;
    const bullets = swiper.passedParams.pagination;
    if (!swiper || !bullets) return;
    swiper.removeAllSlides();
    const slides = document.querySelectorAll(`.cb-variants-related-images [data-for-variant="${variantId}"]`);
    if (slides.length <= 1) {
        hideVariantsImages();
    } else {
        slides.forEach((el, i) => { 
            swiper.addSlide(i, el.cloneNode(true));
        });
        swiper.update();
        showVariantsImages();
    }
}
function showVariantsImages () {
    const swiper = window.variantsImagesSwiper;
    const bullets = document.querySelector('.cb-swiper-pagination-wrapper');
    swiper.el.classList.remove('cb-hidden');
    bullets.classList.remove('cb-hidden');
    document.querySelector('.theme-viewport.swiper-container').classList.add('cb-hidden');
}

function hideVariantsImages () {
    const swiper = window.variantsImagesSwiper;
    const bullets = document.querySelector('.cb-swiper-pagination-wrapper');
    swiper.el.classList.add('cb-hidden');
    bullets.classList.add('cb-hidden');
    document.querySelector('.theme-viewport.swiper-container').classList.remove('cb-hidden');
}

document.addEventListener('DOMContentLoaded', function () {
  // Raster-Layout für die Logos
  const style = document.createElement('style');
  style.textContent = `
    .logo-list-wrapper .logo-list:not(.slick-initialized) {
      display: grid !important;
      grid-template-columns: repeat(5, 1fr) !important;
      gap: 30px !important;
    }

    .logo-list-wrapper .logo-list:not(.slick-initialized) > * {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
    }

    @media (max-width: 990px) {
      .logo-list-wrapper .logo-list:not(.slick-initialized) {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }

    @media (max-width: 600px) {
      .logo-list-wrapper .logo-list:not(.slick-initialized) {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }
  `;
  document.head.appendChild(style);

  function disableLogoSlider() {
    if (!window.jQuery || !jQuery.fn.slick) return;

    jQuery('.logo-list-wrapper .logo-list.slick-initialized')
      .each(function () {
        jQuery(this).slick('unslick');
      });
  }

  // Slider deaktivieren
  disableLogoSlider();

  // Auch bei nachträglicher Initialisierung deaktivieren
  let scheduled = false;

  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      disableLogoSlider();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', disableLogoSlider);
  window.addEventListener('resize', disableLogoSlider);
});

// Macht den Umbruch im Medals Badge von Judge.me
document.querySelectorAll('.jdgm-verified-wrapper svg').length

// Cookie-Einstellungen: Link #cookie-einstellungen oeffnet Shopifys Cookie-Banner (Einstellungen-Dialog).
// Fallback, falls der Banner (noch) nicht geladen ist: Banner per Customer Privacy API neu anzeigen lassen.
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href$="#cookie-einstellungen"]');
  if (!a) return;
  e.preventDefault();
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return; }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    });
  }
});

// Sprach-Hinweis statt automatischer Umleitung: Weicht die Browsersprache von der Seitensprache ab und gibt es
// diese Seite (hreflang, gleiche Domain) in der Browsersprache, erscheint unten ein kleiner Hinweis. Kein Redirect.
(function () {
  var KEY = 'parax_lang_hint';
  if (document.cookie.indexOf(KEY + '=') > -1 || /bot|crawl|spider|slurp/i.test(navigator.userAgent)) return;
  var page = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var want = String((navigator.languages && navigator.languages[0]) || navigator.language || '').slice(0, 2).toLowerCase();
  var T = {
    de: ['Diese Seite gibt es auch auf Deutsch.', 'Auf Deutsch ansehen', 'Schließen'],
    en: ['This page is also available in English.', 'Switch to English', 'Close'],
    fr: ['Cette page existe aussi en français.', 'Voir en français', 'Fermer'],
    es: ['Esta página también está disponible en español.', 'Ver en español', 'Cerrar'],
    it: ['Questa pagina è disponibile anche in italiano.', 'Vedi in italiano', 'Chiudi']
  };
  if (!want || want === page || !T[want]) return;
  var href = null;
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (l) {
    var h = l.getAttribute('hreflang').toLowerCase();
    if (!href && (h === want || h.indexOf(want + '-') === 0) && new URL(l.href).hostname === location.hostname) href = l.href;
  });
  if (!href || href === location.href.split('#')[0]) return;
  var remember = function () { document.cookie = KEY + '=1; path=/; max-age=15552000; samesite=lax'; };
  var css = document.createElement('style');
  css.textContent = '.parax-lang-hint{position:fixed;left:16px;bottom:16px;z-index:9990;max-width:340px;background:#fff;color:#222;' +
    'box-shadow:0 4px 20px rgba(0,0,0,.18);border-radius:6px;padding:14px 40px 14px 16px;font-size:14px;line-height:1.4}' +
    '.parax-lang-hint a{display:inline-block;margin-top:8px;font-weight:600;text-decoration:underline;color:inherit}' +
    '.parax-lang-hint button{position:absolute;top:6px;right:8px;background:none;border:0;font-size:20px;line-height:1;cursor:pointer;color:#666;padding:4px}' +
    '@media (max-width:480px){.parax-lang-hint{right:16px;max-width:none}}';
  var box = document.createElement('div');
  box.className = 'parax-lang-hint';
  box.setAttribute('role', 'region');
  box.setAttribute('lang', want);
  box.setAttribute('aria-label', T[want][1]);
  box.innerHTML = '<span></span><br><a></a><button type="button">&times;</button>';
  box.querySelector('span').textContent = T[want][0];
  var a = box.querySelector('a'); a.href = href; a.textContent = T[want][1]; a.setAttribute('hreflang', want);
  var b = box.querySelector('button'); b.setAttribute('aria-label', T[want][2]);
  a.addEventListener('click', remember);
  b.addEventListener('click', function () { remember(); box.remove(); });
  document.head.appendChild(css);
  document.body.appendChild(box);
})();

// Kaufbox (Skript 33): Steuer-/Versandhinweis folgt dem Preis in den mobilen Kopfbereich
(function () {
  function moveTaxNote() {
    var price = document.querySelector('.mobile-prod-header .price-area');
    var note = document.querySelector('.product-detail__tax-note');
    if (price && note && price.nextElementSibling !== note) price.insertAdjacentElement('afterend', note);
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(moveTaxNote, 0); });
  window.addEventListener('load', moveTaxNote);
})();

// Kaufbox 2 (Skript 37-kaufbox-2): Info-Symbol "Lenkerbreite" - Popover per Klick/Tap, schliessen per Klick ausserhalb/Escape
(function () {
  function closeAll(except) {
    document.querySelectorAll('.kaufbox-info.is-open').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('is-open');
      el.querySelector('.kaufbox-info__btn').setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kaufbox-info__btn');
    if (!btn) { if (!(e.target.closest && e.target.closest('.kaufbox-info__pop'))) closeAll(); return; }
    e.preventDefault();
    var box = btn.parentNode;
    var open = !box.classList.contains('is-open');
    closeAll(box);
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();

// Lieferland (Skript 39): Link "Land waehlen" im Warenkorb scrollt zur Laenderwahl im Footer und oeffnet sie
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-open-country-selector]');
    if (!link) return;
    var toggle = document.querySelector('#localization_form_footer [data-disclosure-country] [data-disclosure-toggle]');
    if (!toggle) return;
    e.preventDefault();
    toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click(); toggle.focus(); }, 400);
  });
})();
